import { FC, useState, useEffect } from 'react';
import './SubmittedLoginForm.scss';

interface IProps {
  sendAgain: () => void;
  isSendAgainLoading: boolean;
}
const startTime: number = 59; // in seconds

const SendAgainTimer: FC<IProps> = ({ sendAgain, isSendAgainLoading }) => {
  const [time, setTime] = useState<number>(startTime);

  useEffect(() => {
    if (time > 0) {
      const timerId = setTimeout(() => {
        setTime((prev) => prev - 1);
      }, 1000);
      return () => clearTimeout(timerId);
    }
  }, [time]);

  const handleClick = () => {
    if (time === 0) {
      sendAgain();
      setTime(startTime);
    }
  };

  const formattedTime = `00:${time < 10 ? `0${time}` : time}`;

  if (isSendAgainLoading) return <div className='timer'>Sending...</div>;

  if (time !== 0) {
    return (
      <>
        <p className='email'>Didn’t get an email?</p>
        <div className={'timer'}>Retry in {formattedTime}</div>
      </>
    );
  }

  return (
    <div className='resent' onClick={handleClick}>
      Resent email
    </div>
  );
};

export default SendAgainTimer;
